import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';
type BookMsg = ws.BookMsg;

export const bookMsg$ = wsMsg$.pipe(
  filter((o: BookMsg) => !!o.book || !!o.orderbook_p),
  map((o) => {
    const {orderbook_p, book, ...data} = o;
    return {...data, book: book ? book : {asks: convertBook(orderbook_p.asks), bids: convertBook(orderbook_p.bids)}};
  })
);

function convertBook(books) {
  return books.map((book) => book.map((o) => Number(o)));
}
